import React from 'react'
import { AppLayout } from '../../layouts/AppLayout'
import { PageHeader } from '../../layouts/PageHeader'
import { PROJECT_ANALYSIS_PAGE_TITLE } from './constants'

function SkeletonBlock({ className = 'h-24' }: { className?: string }) {
  return (
    <div
      className={`rounded-xl bg-slate-200/80 animate-pulse ${className}`}
    />
  )
}

export function ProjectOverviewLoading() {
  return (
    <AppLayout>
      <PageHeader title={PROJECT_ANALYSIS_PAGE_TITLE} />
      <div className="p-6 space-y-6 max-w-[1600px] pb-12">
        <div className="grid grid-cols-2 xl:grid-cols-4 gap-3">
          {Array.from({ length: 4 }).map((_, i) => (
            <SkeletonBlock key={i} className="h-28" />
          ))}
        </div>
        <SkeletonBlock className="h-72" />
      </div>
    </AppLayout>
  )
}
